import { axiosInstance } from "../axios";
import { getCookie, JAVALANG, CANONICAL_COUNTRY_CODE, ORGANIZATION_ID, UTC_OFFSET, LANG, USER_NAME } from "@/utils"

// 获取权限接口
export function fetchGetPermissions(params) {
    // return axiosInstance.get('/ark/auth/getPermissions', { params });
    return axiosInstance.get('/ark/arkservice/auth/getPermissions', { params });
}

// 获取工具
export function fetchGetValidToolList(params) {
    return axiosInstance.post('/ark/infoTool/getValidToolList', params);
}

// 用户类型 业务线 渠道
export function fetchFindTicketCreateQueryOptions(params) {
    // return axiosInstance.get('/ark/field/findTicketCreateQueryOptions', { params })
    return axiosInstance.get('/ark/arkservice/field/findTicketCreateQueryOptions', { params })
}

// 城市列表
export function fetchFindAllCity(params) {
    // return axiosInstance.get('/ark/common/findAllCity', { params })
    return axiosInstance.get('/ark/arkservice/common/findAllCity', { params })
}

// 获取所有分组 根据transformable=1可流转查询所有可流转的组类别
export function fetchAllUserGroups(params) {
    // return axiosInstance.get('/ark/group/getAllUserGroups', { params })
    return axiosInstance.get('/ark/arkservice/group/getAllUserGroups', { params })
}

// 获取手机号及国家码 列表
export function getCountryCellList(params) {
    return axiosInstance.get('/ark/arkservice/common/getCountryList', { params })
}

// 获取邮箱列表
export function fetchListAllTitleByUserId(params) {
    return axiosInstance.get('/ark/arkservice/emailTemplate/listAllTitleByUserId', { params })
}

// im右边创建工单的时埋点
export function imActionRecordTranslate(params) {
    return axiosInstance.post('/im-web/seat/actionRecord', params)
}

// 在线/话后处理状态，客服操作记录
export function getActionRecord (params) {
    return axiosInstance.get('/ark/staffStatus/actionRecord', { params })
}

// 放量开关控制
export const getGrayPermissionList = () => {
    return axiosInstance.get(`/ark/arkservice/apollo/getGrayPermissionList`, {
      params: {
        countryCode: CANONICAL_COUNTRY_CODE,
        orgId: ORGANIZATION_ID,
        userName: USER_NAME,
        lang: JAVALANG,
        utcOffset: UTC_OFFSET,
        settingKeys: "grayPermissionWorkbenchStatus",
      }
    })
}
// sop跳过和控制内部回复弹窗放量开关控制
export const getGrayPermissionByWorkbenchType = (params) => {
    return axiosInstance.get(`/ark/arkservice/apollo/getGrayPermissionByWorkbenchType`, { params })
}